import { defaultCurrencyFormatter, TableField } from "../../table-field";

const nrEmenda: TableField = {
    key: "NrEmenda",
    label: "Número",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const ano: TableField = {
    key: "NrAnoEmenda",
    label: "Ano",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const autor: TableField = {
    key: "NmAutor",
    label: "Autor",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const dtEmenda: TableField = {
    key: "DtEmenda",
    label: "Data",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: val => val ? new Date(val).toLocaleDateString() : '',
};
const tipoEmenda: TableField = {
    key: "TipoEmenda",
    label: "Tipo",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const valor: TableField = {
    key: "VlEmenda",
    label: "Valor",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: defaultCurrencyFormatter,
};
const situacao: TableField = {
    key: "FlAtivo",
    label: "Situação",
    tdClass: ["align-middle", "naoQuebrar", "text-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
};

export const fieldsEmendas: TableField[] = [
    nrEmenda,
    ano,
    tipoEmenda,
    autor,
    dtEmenda,
    valor,
    situacao,
    actions,
];